/**
 * Model configuration
 */
export const config = {
  modelName: 'loader',
} as const;
